import { Component, OnInit } from '@angular/core';
import { faCheckCircle, faCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../shared/services/app.service';
import { JiraUserService } from '../shared/services/jira-user.service';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
declare var $: any;

@Component({
  selector: 'app-jira-bugs-list',
  templateUrl: './jira-bugs-list.component.html',
  styleUrls: ['./jira-bugs-list.component.scss']
})

export class JiraBugsListComponent implements OnInit {
  jiraProjectData: any;
  index: any = 0;
  totalNotificationCount: any = 0;
  nextCount: any = 0;
  prevCount: any = 0;
  buglist: any;
  skipNotifyCount: any = 0;
  maxNotifyCount: any = 0;
  faCircle = faCircle;
  faCheckCircle = faCheckCircle;
  faSearch = faSearch;

  myTopScrollBtn = document.getElementById('scrollToTpBtn');
  userName: any;
  projectName: any;
  projectId: any;
  // project: any;
  project: any = { projectDetails: { name: '', description: '' }, jiraProjectDetails: { name: '', id: '', url: '' } };
  jiraLogin: any = { username: 'sreesailam.avinash489@gmail.com', password: 'M3rOpjkP29RxanDi6Y0QFF3F', jiraurl: 'https://dosmarttesting.atlassian.net' };
  // jiraLogin: any = { username: '', password: '', jiraurl: '' };
  loginDetails: any;
  jiraProjectUrDetails: any;
  jiraStoriesList: any = [];
  searchText:any = '';

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private cookieService: CookieService,
    private AppService: AppService,
    public translate: TranslateService,
    private JiraUserService: JiraUserService

  ) {
    const browserLang = this.cookieService.get('language');
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
  }


  ngOnInit(): void {
    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    // this.loadData();
    this.userName = window.localStorage.getItem('userName');
    this.projectName = window.localStorage.getItem('projectName');
    this.projectId = window.localStorage.getItem('projectID');
    this.getProjectData();
  }

getProjectData(){
  this.ProjectServices.getProject(
    window.localStorage.getItem('projectID')
  ).subscribe((response: any) => {
    // console.log('resss', response);
    if (response.statusCode == 200) {
      this.project = response.record;
      // console.log('this.project', this.project.invites);
      this.getProjectTasksList(response.record);
    } else {
    }
  });
}

  getProjectTasksList(proDetails: any) {
    // console.log('proDetails', proDetails);
    // console.log('this.loginDetails', this.loginDetails);
    if (proDetails.jiraProjectDetails.url) {
      this.jiraProjectUrDetails = this.loginDetails.jiraDetails.find(
        (det: any) => det.url == proDetails.jiraProjectDetails.url
      );
      this.jiraLogin = { username: this.jiraProjectUrDetails.email, password: this.jiraProjectUrDetails.token, jiraurl: this.jiraProjectUrDetails.url };
      let authorizationData = 'Basic ' + btoa(this.jiraProjectUrDetails.email + ':' + this.jiraProjectUrDetails.token);
      this.JiraUserService.getAllJiraStories(authorizationData, proDetails.jiraProjectDetails, this.skipNotifyCount).subscribe((response: any) => {
        // console.log("getAllJiraStories", response);
        this.jiraStoriesList = response.issues;
        this.loadData(response.issues);
      });
    } else {
      // this.jiraLogin = { username: '', password: '', jiraurl: '' };
    }
  }

  loadData(pro: any) {
    // console.log('this.project', pro);
    this.jiraProjectData = pro;
    // console.log('this.jiraProjectData1234', this.jiraProjectData);
    // this.addBugtoDisplay(this.jiraProjectData);
  }

  // list of notification
  addBugtoDisplay(jiraArry: any) {
    // console.log('jiraArry', jiraArry);
    this.buglist = '';
    $('#jiraBugArrayList').empty();
    if (jiraArry.length > 0) {
      for (let k = 0; k < jiraArry.length; k++) {
        this.buglist += '<div> Project name: ' + jiraArry[k].fields.project.name + '</div>';
        this.buglist += '<div> Id: ' + jiraArry[k].id + '</div>';
        this.buglist += '<div> Type: ' + jiraArry[k].fields.issuetype.name + '</div>';
        this.buglist += '<div> Desc: ' + jiraArry[k].fields.issuetype.description + '</div>';
        this.buglist += '<div> Assignee: ' + jiraArry[k].fields.assignee.displayName + '</div>';
        this.buglist += '<div> Status: ' + jiraArry[k].fields.status.name + '</div>';
        this.buglist += '<div> Summary: ' + jiraArry[k].fields.summary + '</div>';
        this.buglist += '<div> Created date: ' + jiraArry[k].fields.created + '</div>';
        this.buglist += '<div> Created by: ' + jiraArry[k].fields.creator.displayName + '</div>';
        if (k != jiraArry.length) {
          this.buglist += '<hr class="notify-hr" />';
        }
      }
      $('#jiraBugArrayList').append(this.buglist);
    } else {
      this.buglist = '<div><b>No more stories<b/></div>';
      $('#jiraBugArrayList').append(this.buglist);
    }
  }

  loadJiraStoryDetails(jiraArry:any){
    // console.log('jiraArry', jiraArry);
    this.buglist = '';
    $('#jiraBugArrayList').empty();
    this.buglist += '<h3>' + jiraArry.fields.summary + '</h3>';
    this.buglist += '<div> Project name: ' + jiraArry.fields.project.name + '</div>';
    this.buglist += '<div> Id: ' + jiraArry.id + '</div>';
    this.buglist += '<div> Type: ' + jiraArry.fields.issuetype.name + '</div>';
    this.buglist += '<div> Desc: ' + jiraArry.fields.issuetype.description + '</div>';
    this.buglist += '<div> Assignee: ' + jiraArry.fields.assignee.displayName + '</div>';
    this.buglist += '<div> Status: ' + jiraArry.fields.status.name + '</div>';
    // this.buglist += '<div> Summary: ' + jiraArry.fields.summary + '</div>';
    this.buglist += '<div> Created date: ' + jiraArry.fields.created + '</div>';
    this.buglist += '<div> Created by: ' + jiraArry.fields.creator.displayName + '</div>';
    $('#jiraBugArrayList').append(this.buglist);

  }
  getAllNotifications(count: any, registeredOn: any) {
    if(count == 'next'){
      this.skipNotifyCount++;
    }
    if(count == 'prev'){
      this.skipNotifyCount--;
    }
    // console.log(this.skipNotifyCount);
    this.getProjectData();
   }
  createActivity(appname: any) { }
  printWindow(){}
  scrollToTopFunction(){}
}
